import { render, staticRenderFns } from "./Promotools.vue?vue&type=template&id=ec9eec00&scoped=true"
import script from "./Promotools.vue?vue&type=script&lang=js"
export * from "./Promotools.vue?vue&type=script&lang=js"
import style0 from "./Promotools.vue?vue&type=style&index=0&id=ec9eec00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9eec00",
  null
  
)

export default component.exports